import Plugin from "@ckeditor/ckeditor5-core/src/plugin";
import DeleteWebemaillinkCommand from "./deletewebemaillinkcommand";
import { CkeditorConstants } from "../../src/utils/ckeditorconstants";

const {
  htmlElement: { LINK_SPAN, SPAN },
} = CkeditorConstants;
export default class DeleteWebemaillinkUI extends Plugin {
  init() {
    const editor = this.editor;
    const attributeLinkingTypes = CkeditorConstants.attributeLinkingTypes;
    editor.commands.add(
      CkeditorConstants.command.DELETE_WEB_EMAIL_LINK,
      new DeleteWebemaillinkCommand(editor)
    );

    const trackChangesEditing = editor?.plugins?.get?.("TrackChangesEditing");
    trackChangesEditing?.descriptionFactory.registerDescriptionCallback(
      (suggestion) => {
        const { attributes } = suggestion;
        if (
          !attributes ||
          attributes.commandName !==
            CkeditorConstants.command.DELETE_WEB_EMAIL_LINK
        ) {
          return;
        }

        const content = `*Remove link:* ${attributes.commandParams.linkAddress}`;
        return {
          type: "deletion",
          content,
        };
      }
    );

    trackChangesEditing?.enableCommand(
      CkeditorConstants.command.DELETE_WEB_EMAIL_LINK,
      (executeCommand, options) => {
        const { linkText, linkAddress } = options;
        editor.model.change((writer) => {
          const selection = editor.model.document.selection;
          const linkTextEvent = linkText;
          const linkAddressEvent = linkAddress;
          const { model: { document: { selection: { anchor } } } } = editor;
          const isLinkAtStart = anchor?.isAtStart;
          const getChildNodes = anchor?.parent?._children?._nodes.find(node => node?.name === LINK_SPAN);  

          // Get the children of the current selection's parent node if the selection is not at the start of a link
          const arrText = isLinkAtStart 
          ? Array.from(getChildNodes.getChildren())
          : Array.from(selection.getFirstPosition().parent.getChildren());

          let idxToRemove = arrText.findIndex((t) => t._data === linkTextEvent);
          idxToRemove = idxToRemove >= 0 ? idxToRemove : 0;

          const elementSelected = arrText[idxToRemove].parent;
          const editingRootDomElement =
            editor.editing.view.domRoots.get("main");
          if (
            (elementSelected.name === LINK_SPAN ||
              elementSelected.name === SPAN) &&
            elementSelected.hasAttribute(
              CkeditorConstants.helperAttributes.RESOURCE
            ) &&
            elementSelected.getAttribute(
              CkeditorConstants.helperAttributes.RESOURCE
            ) === linkAddressEvent &&
            elementSelected.hasAttribute(
              CkeditorConstants.helperAttributes.TYPE_OF
            ) &&
            attributeLinkingTypes.includes(
              elementSelected.getAttribute(
                CkeditorConstants.helperAttributes.TYPE_OF
              )
            )
          ) {
            const selectedLinkId = elementSelected.getAttribute(
              CkeditorConstants.htmlAttributes.ID
            );
            const elementToRemove = editingRootDomElement.querySelector(
              `[id='${selectedLinkId}']`
            );

            if (
              elementToRemove &&
              elementToRemove.querySelector(
                `.${CkeditorConstants.elementClass.suggestion_marker}`
              )
            ) {
              this.removeLinkOnSuggestion(elementToRemove, trackChangesEditing);
            } else {
              const range = editor.model.createRangeIn(elementSelected);
              trackChangesEditing.markDeletion(range, "deleteLink", {
                commandParams: { ...options, removeLinkFromTrackChanges: true },
                commandName: CkeditorConstants.command.DELETE_WEB_EMAIL_LINK,
              });
            }
          } else {
            const children = selection.getFirstPosition().parent.getChildren();
            if (Symbol.iterator in Object(children)) {
              for (let child of children) {
                if (
                  child.hasAttribute("linkHref") &&
                  child._data === linkTextEvent
                ) {
                  const rangeLinkHref = editor.model.createRangeOn(child);
                  this.editor.model.change((writer) => {
                    trackChangesEditing.markDeletion(
                      rangeLinkHref,
                      "deleteLink",
                      {
                        commandParams: {
                          ...options,
                          removeLinkFromTrackChanges: true,
                        },
                        commandName:
                          CkeditorConstants.command.DELETE_WEB_EMAIL_LINK,
                      }
                    );
                  });
                }
              }
            } else {
              executeCommand(options);
            }
          }
        });
      }
    );
  }

  removeLinkOnSuggestion(elementToRemove, trackChangesEditing) {
    const eleMarkerSuggestion = elementToRemove.querySelector(
      `.${CkeditorConstants.elementClass.suggestion_marker}`
    );

    if (
      elementToRemove.getAttribute(
        CkeditorConstants.helperAttributes.TYPE_OF
      ) &&
      CkeditorConstants.attributeLinkingTypes.includes(
        elementToRemove.getAttribute(CkeditorConstants.helperAttributes.TYPE_OF)
      ) &&
      eleMarkerSuggestion
    ) {
      const dataSuggestionChild = eleMarkerSuggestion.getAttribute(
        CkeditorConstants.trackchangesMarkup.SUGGESTION
      );

      const idLinkEle = elementToRemove.getAttribute(
        CkeditorConstants.htmlAttributes.ID
      );
      let eleToRemove = null;
      const range = this.editor.model.createRangeIn(
        this.editor.model.document.getRoot()
      );
      for (const item of range.getItems({ ignoreElementEnd: true })) {
        if (
          (item.name === LINK_SPAN || item.name === SPAN) &&
          item.getAttribute(CkeditorConstants.htmlAttributes.ID) === idLinkEle
        ) {
          eleToRemove = item;
        }
      }
      this.editor.model.change((writer) => {
        writer.unwrap(eleToRemove);
        const suggestion =
          trackChangesEditing.getSuggestion(dataSuggestionChild);
        const [markerName] = suggestion.getMarkerNames();
        writer.removeMarker(markerName);
      });
    }
  }
}
